import React , { useState, useRef, useEffect } from 'react';
import app from "./app" 
import {GridWrap, ListWrap, Elements} from "./helpers" 



export const FaqOne = function({data, device, widgetType, mode}) {
    useEffect(()=>{
        if(app.getMode(mode)){ 
         
        }  
    },[])
    const collapseFaq = function(id){
        
        if(app.getMode(mode)){ 
            const ele = document.querySelector(`#${id}`);
            const collapseDiv = ele.querySelector(".accordion-collapse");
            console.log(ele,collapseDiv,"ele...")
            if(ele.classList.contains("show")) {
                ele.classList.remove("show");
                collapseDiv.style.maxHeight = "0px";
            }
            else {
                ele.classList.add("show");
                collapseDiv.style.maxHeight = collapseDiv.scrollHeight + "px"; 
            }
        }  

    }
    let faqList = "";    
    if(data.elements.faqList){
        faqList = data.elements.faqList.items.map(function (v,i) {
            let iconColor = v.heading.properties.textColor; 
            let show = "";
            
            if(mode === "edit") {
                show = "show";
            }
            else {
                if(v.properties.collapse) {
                    show = "show"
                }
            }

            const faqId = `faq${data.viewId}${i}`;

            return  <GridWrap data={v} key={'key-' + v.gridId + i} id="faqList" mode={mode} device={device} className={`${show}`}>
                <div className={`${show} row m-0 faq-accordion`} id={faqId}>
                    <div className="col-12 p-0">
                        <div className="d-flex justify-content-between align-items-center faq-accordion-head gap-3" onClick={() => collapseFaq(faqId)} style={{
                            "background" : app.elementBackground(v.heading.properties.background, v.heading.properties.backgroundType, v.heading.properties.overlayColor)}}>
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} classType="w-100"/> 
                            <span className={`ic_ai_icon_arrow_1 collapse-icon`} style={{ color:app.getColor(iconColor)}}></span>
                        </div>
                        
                        <div className={`accordion-collapse`} style={{ maxHeight: show ? "none" : "0px", overflow: "hidden", transition: "max-height 0.3s ease-in-out" }}>
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} classType="accordion-body"/>
                        </div>
                    </div> 
                </div>
            </GridWrap>
        })

        faqList = <ListWrap data={data.elements.faqList} grid={true} mode={mode} className="align-items-stretch justify-content-center">
                {faqList}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} /> 
            </div>
        </div>
        {faqList}
    </div>
}